import { render, staticRenderFns } from "./CopyUrlButton.vue?vue&type=template&id=a25669f0&scoped=true&"
import script from "./CopyUrlButton.vue?vue&type=script&lang=js&"
export * from "./CopyUrlButton.vue?vue&type=script&lang=js&"
import style0 from "./CopyUrlButton.vue?vue&type=style&index=0&id=a25669f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a25669f0",
  null
  
)

export default component.exports